module Meevo.Components.Mover {
    'use strict';

    interface IMoverComponentBindings {
        items: any[];
        itemsKey: string;
        selectedItems: any[];
        unselectedItems: any[];
        isReadonly: boolean;

        onDisplayItem: (item: any) => string;
        onFilter: (item: any) => boolean;
    }

    interface IMoverComponentController extends IMoverComponentBindings {
        move(): void;
        moveAll(): void;
        remove(): void;
        removeAll(): void;
        onDisplayItem(item: any): string;
        onFilter(item: any): boolean;
    }

    export class MoverComponentController implements IMoverComponentController {
        items: any[];
        itemsKey: string;
        selectedItems: any[];
        unselectedItems: any[];
        isReadonly: boolean;

        onDisplayItem: (item: any) => string;
        onFilter: (item: any) => boolean;

        selectedItem: any[];
        unselectedItem: any[];

        $onInit() {
            this.selectedItems = this.selectedItems || [];
        }

        $onChanges = (changes) => {
            if (changes.itemsKey && changes.itemsKey.currentValue) {
                this.itemsKey = changes.itemsKey.currentValue;
            }

            if (changes.selectedItems && changes.selectedItems.currentValue) {
                this.updateSelectedItems(changes.selectedItems.currentValue);
            }

            if (changes.items && changes.items.currentValue) {
                this.unselectedItems = changes.items.currentValue.map((item) => item);

                this.updateSelectedItems(this.selectedItems);
            }
        }

        private updateSelectedItems(selectedItems: any[]) {
            if (!selectedItems || selectedItems.length === 0) {
                return;
            }

            // selectedItems comes in with a set of objects which don't match what is in items list
            // find the equivalent object from items and use that to re-populate selectedItems

            this.unselectedItem = [];
            let unselectedItems = [];

	        const itemsKey = this.itemsKey || 'id';

            for (let itemIndex in selectedItems) {
                if (selectedItems.hasOwnProperty(itemIndex)) {
                    let foundItem = _.find(this.items, item => item[itemsKey] === selectedItems[itemIndex] || item[itemsKey] === selectedItems[itemIndex][itemsKey]);
                    if (foundItem) {
                        unselectedItems.push(foundItem);
                    }
                }
            }

            this.unselectedItems = _(this.items).difference(unselectedItems);
            this.selectedItems = _(this.items).difference(this.unselectedItems);
        }

        private displayItem = (item) => {
            if (!item)
            {
                return;
            }
            
            return this.onDisplayItem 
                ? this.onDisplayItem({ item: item })
                : item.displayName;
        }

        setItems(selectedItems) {
            this.unselectedItems = _(this.items).difference(selectedItems);
            this.selectedItems = _(this.items).intersection(selectedItems);
        }

        move(): void {
            let selectedItems = this.selectedItems.concat(this.unselectedItem);
            this.setItems(selectedItems);
        }

        moveAll(): void {
            let unselectedItems = _(this.unselectedItems).filter(this.unselectedFilter);
            let selectedItems = this.selectedItems.concat(unselectedItems);
            this.setItems(selectedItems);
        }

        remove(): void {
            let selectedItems = _(this.selectedItems).difference(this.selectedItem);
            this.setItems(selectedItems);
        }

        removeAll(): void {
            this.selectedItems = [];
            this.unselectedItems = this.items;
        }

        isMoveDisabled(): boolean {
            return this.isReadonly || !this.unselectedItem || this.unselectedItem.length === 0;
        }

        isMoveAllDisabled(): boolean {
            let unselectedItems = _(this.unselectedItems).filter(item => this.unselectedFilter(item));
            return this.isReadonly || unselectedItems.length === 0;
        }

        isRemoveDisabled(): boolean {
            return this.isReadonly || !this.selectedItem || this.selectedItem.length === 0;
        }

        isRemoveAllDisabled(): boolean {
            return this.isReadonly || !this.selectedItems || this.selectedItems.length === 0;
        }

        unselectedFilter = (value): boolean => {
            if (!this.onFilter) {
                return true;
            }

            return this.onFilter({ item: value });
        }
    }

    export class MoverComponent implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                items: '<',
                itemsKey: '@?',
                selectedItems: '=',
                isReadonly: '<',

                onDisplayItem: '&?',
                onFilter: '&?',
            };

            this.controller = MoverComponentController;
            this.templateUrl = 'app/components/mover/mover.template.html';
        }
    }

    angular.module('meevo.components.mover')
        .component('meevoMoverTool', new MoverComponent());
}